// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'document-solid';

export const Component = () => (
  <path d='M16.225 7.855h6.37v15.182c0 .431-.144.766-.432 1.054a1.408 1.408 0 0 1-1.054.43H3.485a1.41 1.41 0 0 1-1.054-.43A1.408 1.408 0 0 1 2 23.037V1.485c0-.431.144-.766.431-1.054A1.408 1.408 0 0 1 3.485 0H14.74v6.37c0 .43.144.766.431 1.053.288.288.623.432 1.054.432Zm0-1.007h6.034l-.096-.096L15.698.287l.047 6.082c0 .335.144.479.48.479Z' />
);

export const viewBox = '0 0 25 25';
